import React, { useState } from "react";

import {
    View,
    Modal,
    Text,
    TouchableOpacityProps,
    TouchableOpacity,
    Platform,
    StyleSheet
} from "react-native";
import { ActivityAction } from "../../screens/activities/ActivitySheetScreen";
import AppTheme from "../../utils/Theme";
import Style from "../../utils/Style";
import SVGView from "../../utils/SvgView";
import { IcDocument, IcHtmlDoc, IcPlay, IcTapuscrit } from "../../utils/Icons";
import { SvgProps } from "react-native-svg";
import { getStringFromMatrixLocalizedString } from "../../screens/rooms/FamilyRoom";
import ActivityPlayer from "../Audio/ActivityPlayer";
import Activity from "../../models/Activity";
import Images from "../../../specific/utils/Images";
import { getLanguage } from "../../utils/Localization/Localization";
import DocumentsViewer from "../Documents/DocumentsViewer";
import { addDataToUser, onActivityCompleted } from "../../services/Firebase/Database";
import { analyticsEventActivityCompleted, propertiesEventAccess, propertiesEventCategory, propertiesEventContent, propertiesEventContext, propertiesEventName, trackEvent } from "../../services/Tracking/Analytics";
import User from "../../data/user/User";

const KNOWN_ACTION_TYPES: string[] = ["audio", "doc", "video"];

interface ActionButtonProps extends TouchableOpacityProps {
    activity: Activity;
    action: ActivityAction;
    backgroundColor?: string;
}

const ActionButton = (props: ActionButtonProps) => {

    const appTheme: AppTheme = new AppTheme();
    const images: Images = new Images;

    const { action, activity, backgroundColor = appTheme.darkBlue } = props;

    const [launchAction, setLaunchAction] = useState<boolean>(false);

    const onActionCompleted = () => {
        console.log({activity})
        onActivityCompleted({
            activityKey: activity.key,
            sectionKey: activity.section_key,
            categoryKey: activity.category_keys[0],
            iteration: 1,
            detail: "",
            menu: ""
        });
        const user: User = User.getInstance();
        let userMedia = {};
        if (user.media !== undefined) {
            userMedia = user.media;
        }
        const categoryKey: string | undefined = activity.category_keys[0];
        if (categoryKey !== undefined) {
            let userMediaForCategory = [];
            if (userMedia[categoryKey] !== undefined) {
                userMediaForCategory = userMedia[categoryKey];
            }
            if (userMediaForCategory.indexOf(activity.key) === -1) {
                userMediaForCategory.push(activity.key);
                userMedia[categoryKey] = userMediaForCategory;
                user.media = userMedia;
                addDataToUser({ key: "media", value: userMedia, user_id: user.uid });
            }
        }

        trackEvent(analyticsEventActivityCompleted, {
            [propertiesEventCategory]: "BRAIN_PROGRAMS",
            [propertiesEventContent]: "audio",
            [propertiesEventAccess]: activity.access.is_premium === true ? "premium" : "free",
            [propertiesEventContext]: "neuroscience",
            [propertiesEventName]: activity.analytics_key,
            "starting_point": "neuroscience"
        });
    }

    const onActionLaunchRequest = () => {
        if (KNOWN_ACTION_TYPES.indexOf(action.type) !== -1) {
            setLaunchAction(true);
        }
    }

    const renderModalContent = (): React.JSX.Element | null => {
        if (launchAction === true) {
            if (action.type === "audio") {
                return <ActivityPlayer
                    activityKey={activity.key}
                    title={activity.title[getLanguage()]}
                    notificationImage={Platform.OS === "ios" ? activity.img_url : images[activity.app_image]}
                    onActivityCompleted={onActionCompleted}
                    urls={[getStringFromMatrixLocalizedString(action.url)]}
                    color={backgroundColor}
                    localImage={images[activity.app_image]}
                    remoteImage={activity.img_url}
                    togglePlayer={() => setLaunchAction(false)} />
            } else if (action.type === "doc") {
                const documentId: string | undefined = getStringFromMatrixLocalizedString(action.doc_id);
                return <DocumentsViewer
                    onDocumentCloseRequest={() => setLaunchAction(false)}
                    documentId={documentId} />
            } else if (action.type === "video") {
                
            }
        }

        return null;
    }

    let iconName: React.FC<SvgProps> = IcPlay;
    let iconSize: number = appTheme.pixelPerfect(28);
    if (action.type === "doc") {
        iconName = IcHtmlDoc;
    }

    let titleView: React.JSX.Element | null = null;
    if (action.title !== undefined) {
        let titleString: string | undefined = getStringFromMatrixLocalizedString(action.title);
        if ((titleString !== undefined) && (titleString.length > 0)) {
            titleView = <Text style={{ textAlign: "center", textTransform: "uppercase", paddingTop: appTheme.pixelPerfect(10), fontFamily: appTheme.primaryBoldFont, color: backgroundColor, fontSize: appTheme.pixelPerfectForFont(12), alignItems: "center" }}>
                {titleString}
            </Text>;
        }
    }

    return (<View key={action.key} style={{ alignItems: "center", width: appTheme.pixelPerfect(120) }}>
        <TouchableOpacity
            onPress={onActionLaunchRequest}
            style={[Style.shadowed, {
                justifyContent: "center",
                alignItems: "center",
                borderRadius: appTheme.pixelPerfect(40),
                width: appTheme.pixelPerfect(80),
                height: appTheme.pixelPerfect(80),
                backgroundColor: backgroundColor
            }]}
            {...props}>
            <SVGView Component={iconName} size={iconSize} color={appTheme.white} />
        </TouchableOpacity>
        {titleView}
        <Modal animationType="slide" visible={launchAction} transparent={true} style={{ width: appTheme.getFullScreenWidth(), height: "100%" }}>
            <View style={[styles.modal_container, { paddingLeft: appTheme.webNavBarWidth, width: appTheme.getFullScreenWidth() }]}>
                {renderModalContent()}
            </View>
        </Modal>
    </View>
    )
}

export default ActionButton;

const styles = StyleSheet.create({
    modal_container: {
        flex: 1,
        alignItems: "center",
        justifyContent: "flex-end",
        backgroundColor: "#FFFFFF80"
    }
});
